export default __webpack_public_path__ + "static/media/12.2c8ce9b0.PNG";